import { useEffect, useState } from "react"
import { useApiService } from "../hooks/Api/useApiService"
import { Typography, Alert, Box, Fade } from "@mui/material"
import SharieSkeleton from "../UI/SharieSkeleton"
import TopSkill from "./TopSkill"
import styles from "./TopSkills.module.css"
import useTranslationSharie from "../hooks/Language/useTranslation"
import i18n from "i18next"
import useError from "../hooks/Error/useError"

const TopSkills = () => {
  const [loading, setLoading] = useState(false)
  const [skills, setSkills] = useState([])
  const { getData } = useApiService()
  const t = useTranslationSharie()
  const isHebrew = i18n.language === "he"
  const { Error: AlertError, error } = useError()

  const getTopSkills = async () => {
    try {
      setLoading(true)
      const data = await getData("skills/gettopskills", null)

      setSkills(data.skills || []) // trigger fade in
      setLoading(false)
    } catch (err) {
      error("Failed to load skills. Please try again later.")
    }
  }

  useEffect(() => {
    getTopSkills()
  }, [])

  if (loading)
    return (
      <Box className={styles.topskills_container}>
        <SharieSkeleton variant='rectangular' width={"300px"} height={"800px"} />
      </Box>
    )
  return (
    <Fade in={true} timeout={500}>
      <Box className={styles.topskills_container}>
        <Typography
          variant='h6'
          color='text.secondary'
          gutterBottom
          sx={{ textAlign: !isHebrew ? "right" : "left" }}
        >
          {t("Top Rated Skills")}
        </Typography>
        {skills?.map((el, index) => (
          <TopSkill key={index} skill={el} isHebrew={isHebrew} />
        ))}
        <AlertError />
      </Box>
    </Fade>
  )
}

export default TopSkills
